import { FC, forwardRef, ReactNode } from 'react';

import { styled } from '@mui/material/styles';

import Box from '@o2/ui/Box';
import Stack, { StackProps } from '@o2/ui/Stack';

import Item from './Item';

export interface ListProps extends StackProps {
  disableDivider?: boolean;
  showCreatingRow?: boolean;
  /**
   * Content rendered in an extra `List.Item` when `showCreatingRow` is `true`.
   */
  creatingRow?: ReactNode;
}

type List = FC<ListProps> & {
  Item: typeof Item;
};

const ListRoot = styled(Stack)<ListProps>(({ disableDivider, theme }) => ({
  '& > div': {
    borderBottom: disableDivider ? 'none' : `1px solid ${theme.palette.divider}`,
  },
}));

//@ts-expect-error: Property 'Item' is missing in type (FIXME)
const List: List = forwardRef<HTMLDivElement, ListProps>(
  ({ showCreatingRow, creatingRow, children, ...props }, ref) => {
    return (
      <ListRoot {...props} ref={ref}>
        {children}
        {showCreatingRow && (
          <Box pt={1.5} borderBottom="none !important">
            {creatingRow}
          </Box>
        )}
      </ListRoot>
    );
  }
);

List.Item = Item;
List.displayName = 'List';

export default List;
